var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{staticClass:"brewthers-dark-bg"},[_c('q-page-container',{staticStyle:{"padding-top":"0"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }